import Header from './components/Header';
import Calendar from './components/Calendar';
import Footer from './components/Footer';
import logo from './logo.svg';
import './App.scss';

function App() {
  return (
    <div className="App">
      <Header />
      <Calendar />
      <Footer />
    </div>
  );
}

export default App;
